module.exports = "images/doc-client-add.352697fb4af355220809e3bf3ef156f3.png";